<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>Tagged OPCR Targets</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <!-- <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col> -->
              <v-spacer></v-spacer>

              <v-col cols="12">
                <div class="pa-2 d-flex">
                  <div class="text-body font-weight-bold">Type:</div>
                  <div class="text-body ml-2">
                    {{ tab == 1 ? "Core Function" : "Strategic Priority" }}
                  </div>
                </div>
                <div class="pa-2 d-flex align-center">
                  <div class="text-body font-weight-bold">MFO:</div>
                  <div class="text-body ml-2">{{ data && data.mfo }}</div>
                </div>
                <div class="pa-2 d-flex align-center">
                  <div class="text-body font-weight-bold">Target:</div>
                  <div class="text-body ml-2">
                    {{
                      tab == 1 ? data && data.efficiency : data && data.target
                    }}
                  </div>
                </div>
                <div class="pa-2 d-flex">
                  <div class="text-body font-weight-bold">
                    Sucess Indicator:
                  </div>
                  <div class="text-body ml-2">
                    {{ data && data.success_indicator }}
                  </div>
                </div>
                <div class="pa-2 d-flex">
                  <div class="text-body font-weight-bold">
                    Actual Accomplishment:
                  </div>
                  <div class="text-body ml-2">
                    {{ data && data.actual_accomplishment }}
                  </div>
                </div>
              </v-col>

              <v-col cols="12" v-if="hasChildTagged">
                <v-divider></v-divider>
                <div class="text-h5 mt-4 pl-2">
                  Tagged office/unit under the
                  <span class="font-weight-bold">
                    {{ hasChildTagged ? parentData.office_name : "" }}
                  </span>
                </div>
              </v-col>
              <v-col cols="12" class="pt-2 px-4">
                <v-data-table
                  :headers="cascade_headers"
                  :items="dataItem"
                  :items-per-page="10"
                >
                  <!-- <template
                    v-slot:item.data-table-expand="{ item, expand, isExpanded }"
                  >
                    <td v-if="item.opcr_target" class="text-start">
                      <v-btn
                        icon
                        @click="expand(!isExpanded)"
                        class="v-data-table__expand-icon"
                        :class="{
                          'v-data-table__expand-icon--active': isExpanded,
                        }"
                      >
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </td>
                  </template>
                  <template v-slot:expanded-item="{ headers, item: parent }">
                    <td :colspan="headers.length" class="pa-4">
                      <div class="text-subtitle-1 py-1">
                        LINKED IPCR
                      </div>

                      <div>
                        <v-data-table
                          :headers="ipcr_headers"
                          :items="
                            parent.opcr_target
                              ? parent.opcr_target.linked_ipcr
                              : []
                          "
                          hide-default-footer
                        >
                        </v-data-table>
                      </div>
                    </td>
                  </template> -->
                  <template v-slot:[`item.efficiency`]="{ item }">
                    <div class="d-flex align-center justify-center">
                      <div class="text-caption" v-if="item.eff_is_rated == 1">
                        {{
                          item.ipcr_rate.e_total
                            ? "(" +
                              item.ipcr_rate.e_total +
                              ") " +
                              item.ipcr_rate.e_avg
                            : null
                        }}
                      </div>
                      <div
                        class="text-caption font-weight-bold"
                        v-if="item.eff_is_rated == 0"
                      >
                        NR
                      </div>
                    </div>
                  </template>
                  <!-- <template v-slot:[`item.action`]="{ item }">
                     <v-btn
                      v-if="item.accomplishments.length > 0"
                      block
                      @click="
                        ViewFileAttached(item.accomplishments[0].attachment)
                      "
                      x-small
                      outlined
                      color="warning"
                      class="my-1"
                      >View Attachment</v-btn
                    >
                </template> -->
                </v-data-table>
              </v-col>
            </v-row>
            <!-- <v-row v-if="isSubmitted && assessed_by_status == 2">
              <v-col cols="12">
                <v-divider></v-divider>
                <div class="pa-3">
                  <div class="text-h6">
                    Comments and Recommendations for Development Purposes:
                  </div>
                  <div class="text-justify text-subtitle-1">
                    {{ targetRating.comments }}
                  </div>
                </div>
              </v-col>
            </v-row> -->
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <!-- <v-fab-transition v-if="isSubmitted">
            <v-menu top>
              <template v-slot:activator="{ on }">
                <v-btn color="#519043" left outlined v-on="on">
                  Remarks
                </v-btn>
              </template>

              <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                <v-card-title class="dialog-header  white--text">
                  <span class="text-h6">Remarks</span>
                </v-card-title>
                <v-card-text
                  class="py-0"
                  style="background-color:white;  height : 300px; overflow-y:auto"
                >
                  <v-timeline dense v-if="remarksData.length > 0">
                    <v-timeline-item
                      v-for="item in remarksData"
                      :key="item.id"
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-h6">
                          {{
                            $store.getters.getUserData.id ==
                            item.remarks_maker_userID
                              ? "You"
                              : item.remarks_by
                          }}
                        </div>
                        <div class="text-body-1">
                          {{ item.message }}
                        </div>
                        <div class="text-caption">
                          <i>{{ formatDate(item.created_at) }}</i>
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                  <v-timeline dense v-if="remarksData.length == 0">
                    <v-timeline-item
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-body-1">
                          No remarks found.
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition> -->
          <v-spacer></v-spacer>

          <v-btn
            color="#519043"
            class="white--text"
            @click="
              !hasAddedAccomplishment
                ? saveAccomplishment()
                : updateAccomplishment()
            "
          >
            {{
              !hasAddedAccomplishment
                ? "Save as Target Accomplishment"
                : "Update Target Accomplishment"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- confirm dialof -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 my-2">
            <div v-html="savingAction"></div>
          </div>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelConfirm()"> CANCEL </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmSave()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddAccomplishmentDialog
      :data="opcrData"
      :action="action"
      :opcrID="id"
      :tab="tab"
    />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    AddAccomplishmentDialog: () =>
      import("../OPCR/AddAccomplishmentDialog.vue"),
  },
  props: {
    data: null,
    myTaggingType: null,
    tab: null,
  },
  data() {
    return {
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      savingAction: null,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      hasChildTagged: false,
      parentData: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      dialog: false,
      //   activeTab: { id: 1, name: "Core Functions" },
      //   tab: 1,
      //   tabList: [
      //     { id: 1, name: "Core Functions" },
      //     { id: 2, name: "Strategic Priority" },
      //   ],
      opcrData: null,
      opcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrSupport: null,
      dataItem: [],
      expanded: [],
      isButtonLoading: false,

      cascade_headers: [
        {
          text: "Office",
          value: "office_name",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        // {
        //   text: "Office Head",
        //   value: "name",
        //   align: "start",
        //   width: 300,
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Tagged Target/s",
          value: "target",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Alloted Budget",
        //   value: "alloted_budget",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Actual Accomplishment",
          value: "opcr_target.actual_accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },

        // {
        //   text: "Action",
        //   value: "action",
        //   width: 150,
        //   align: "end",
        // },
      ],
      sp_headers: [
        {
          text: "Code",
          value: "code",
          width: 100,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Tagged Target/s",
          value: "tagged_target",
          align: "center",
          width: 100,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Actual Accomplishment",
          value: "actual_accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],

      ipcr_headers: [
        {
          text: "Name",
          value: "personnel_name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "rate.success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "rate.actual_accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      support_headers: [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("OPCR CASCADED", data);
        // this.isSubmitted = data.isSubmitted;
        // this.assessed_by = this.toTitleCase(data.assessed_by_name);
        // this.assessed_by_status = data.assesed_by_status;
        this.id = data.id;
        // this.activeTab = { id: 1, name: "Core Functions" };
        // this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  computed: {
    getTotalEfficiency() {
      let total = 0;
      for (let i = 0; i < this.dataItem.length; i++) {
        if (this.dataItem[i].opcr_target) {
          if (this.dataItem[i].opcr_target.opcr_target_accomplishment) {
            total +=
              this.dataItem[i].opcr_target.opcr_target_accomplishment
                .accomplishment;
          }
        }
      }
      return total;
    },
    hasAddedAccomplishment() {
      let has = false;
      if (this.data && this.data.accomplishments.length > 0) {
        has = true;
      }
      return has;
    },
  },

  mounted() {
    this.eventHub.$on("closeAddAccomplishmentDialog", () => {
      this.initialize();
      // this.closeD();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeAddAccomplishmentDialog");
  },

  methods: {
    initialize() {
      this.loading = true;

      let param_id =
        this.myTaggingType.type == "vp"
          ? this.data.id
          : this.data.OpcrPapTargetDistributedTaggingID;

      this.axiosCall(
        "/opcr-target/loadTaggedOPCRTarget/" + param_id + "/" + this.tab,
        "GET"
      ).then((res) => {
        let data = res.data;
        console.log("tagged opcr", data);
        // for (let i = 0; i < data.length; i++) {
        //   data[i].name = this.toTitleCase(data[i].name);
        // }
        if (data.data) {
          this.hasChildTagged = true;
          this.parentData = data;
          this.dataItem = data.data;
        } else {
          this.hasChildTagged = false;
          this.parentData = null;
          this.dataItem = data;
        }
      });
    },

    loadAccomplishment({ item }) {
      let index = this.dataItem.findIndex((e) => e.id == item.id);
      console.log("called index", index, item);

      this.axiosCall(
        "/opcr-target/getAccomplishments/" + item.id + "/" + this.tab,
        "GET"
      ).then((res) => {
        console.log("da", res.data);
        Object.assign(this.dataItem[index], {
          accomplishments: res.data,
        });

        console.log("data", this.dataItem);
      });
    },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.assessed_by_status == 1 || this.assessed_by_status == 2) {
          return false;
        } else {
          return true;
        }
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/OPCR_TARGET", "GET").then((res) => {
          if (res.data) {
            console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      this.eventHub.$emit("closeViewOPCRLinkedTargetsDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    // add_accomplishment(item) {
    //   console.log("RATEssssss", item);
    //   this.opcrData = {
    //     targetType: this.tab,
    //     targetID:
    //       this.tab == 1
    //         ? item.id
    //         : this.myTaggingType.type == "vp"
    //         ? item.id
    //         : item.OpcrPapTargetDistributedTaggingID,
    //     opcrID: this.id,
    //     taggedTarget: item.target,
    //     QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
    //     timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
    //     Q_rating: item.Q_rating,
    //     T_rating: item.T_rating,
    //     success_indicator: item.success_indicator,
    //     efficiency:
    //       this.tab == 1
    //         ? item.efficiency
    //         : this.myTaggingType.type == "vp"
    //         ? item.target
    //         : item.tagged_target,
    //   };
    //   this.expanded = [];
    //   // console.log("RATE", this.opcrData);
    //   this.action = "Add";
    // },

    // update_accomplishment(item, parent) {
    //   console.log("UPDATE DATA", item, parent);
    //   // this.opcrData = item;
    //   this.opcrData = {
    //     accomplishment: item.accomplishment,
    //     accomplishment_id: item.id,
    //     targetType: this.tab,
    //     targetID: parent.id,
    //     opcrID: this.myTaggingType.type == "vp" ? this.data.id : parent.opcrID,
    //     taggedTarget: parent.target,
    //     QL_is_rated: this.tab == 1 ? parent.QL_is_rated : true,
    //     timeliness_is_rated: this.tab == 1 ? parent.timeliness_is_rated : true,
    //     Q_rating: parent.Q_rating,
    //     T_rating: parent.T_rating,
    //     success_indicator: parent.success_indicator,
    //     efficiency: parent.efficiency,
    //     attachment: item.attachment,
    //     remarks: parent.remarks,
    //   };
    //   this.expanded = [];
    //   this.action = "Update";
    // },

    view_accomplishment(item) {
      this.opcrData = {
        targetType: this.tab,
        targetID:
          this.tab == 1
            ? item.id
            : this.myTaggingType.type == "vp"
            ? item.id
            : item.OpcrPapTargetDistributedTaggingID,
        opcrID: this.id,
        taggedTarget: item.target,
        QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
        timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
        Q_rating: item.Q_rating,
        T_rating: item.T_rating,
        success_indicator: item.success_indicator,
        efficiency:
          this.tab == 1
            ? item.efficiency
            : this.myTaggingType.type == "vp"
            ? item.target
            : item.tagged_target,
      };
      this.expanded = [];
      // console.log("RATE", this.opcrData);
      this.action = "Add";
    },
    submitTarget() {
      this.confirmSubmitDialog = true;
    },

    confirmSubmit() {
      // this.confirmBtnLoading = true;
      // this.isSubmitLoading = true;
      // this.axiosCall("/ipcr-target/submitMyTargets/" + this.id, "PATCH").then(
      //   (res) => {
      //     if (res.data.status == 200) {
      //       this.confirmBtnLoading = false;
      //       this.fadeAwayMessage.show = true;
      //       this.fadeAwayMessage.type = "success";
      //       this.fadeAwayMessage.header = "System Message";
      //       this.fadeAwayMessage.message = res.data.msg;
      this.closeD();
      //     } else if (res.data.status == 400) {
      //       this.fadeAwayMessage.show = true;
      //       this.fadeAwayMessage.type = "error";
      //       this.fadeAwayMessage.header = "System Message";
      //       this.fadeAwayMessage.message = res.data.msg;
      //     }
      //   }
      // );
    },

    confirmSave() {
      this.opcrData = {
        accomplishment: this.getTotalEfficiency,
        accomplishment_id:
          this.data.accomplishments.length > 0
            ? this.data.accomplishments[0].id
            : null,
        targetType: this.tab,
        targetID: this.data.id,
        opcrID: this.data.opcrID,
        taggedTarget: this.tab == 1 ? this.data.efficiency : this.data.target,
        QL_is_rated: this.tab == 1 ? this.data.QL_is_rated : true,
        timeliness_is_rated:
          this.tab == 1 ? this.data.timeliness_is_rated : true,
        Q_rating: this.data.Q_rating,
        T_rating: this.data.T_rating,
        success_indicator: this.data.success_indicator,
        efficiency: this.data.efficiency,
        attachment:
          this.data.accomplishments.length > 0
            ? this.data.accomplishments[0].attachment
            : [],
        remarks: this.data.remarks,
      };
      this.action = this.data.accomplishments.length > 0 ? "Update" : "Add";
      this.confirmDialog = false;
      // this.closeD();
    },

    cancelConfirm() {
      this.confirmDialog = false;
    },

    saveAccomplishment() {
      this.savingAction =
        "<div class='text-justify'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Are you sure you want to <b>SAVE</b> this as your OPCR Target Accomplishment?</div>";
      this.confirmDialog = true;
    },

    updateAccomplishment() {
      this.savingAction =
        "<div class='text-justify'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Are you sure you want to <b>UPDATE</b> your OPCR Target Accomplishment?</div>";
      this.confirmDialog = true;
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    // deleteItem(item) {
    //   this.itemToDelete = item;
    //   this.confirmDialog = true;
    // },
    // cancelDelete() {
    //   this.itemToDelete = null;
    //   this.confirmDialog = false;
    // },

    // confirmDelete() {
    //   this.isButtonLoading = true;
    //   this.axiosCall(
    //     "/opcr-target/deleteAccomplishment/" + this.itemToDelete.id,
    //     "DELETE"
    //   ).then((res) => {
    //     if (res.data.status == 200) {
    //       this.confirmDialog = false;
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "success";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //       this.itemToDelete = null;
    //       this.confirmDialog = false;

    //       this.initialize();
    //     } else {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //     }
    //   });
    // },
  },
};
</script>
<style scoped></style>
